import { components } from 'react-select'
import { DropdownLibraryInputProps } from './dropdown-library-input.props'

export const DropdownLibraryInput =
  (searchable: boolean) => (props: DropdownLibraryInputProps) => {
    return <components.Input readOnly={!Boolean(searchable)} {...props} />
  }
